module.exports = __webpack_public_path__ + "static/media/telegram.74ac3919.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/telegram.svg
// module id = 2475
// module chunks = 7